import {
  Container, Snowflake, Layers, Truck, Zap, Package,
  FileBadge, ShieldCheck, TrendingUp, Search, Calculator, HardHat,
} from 'lucide-react';

export const SERVICE_ICONS = {
  Container, Snowflake, Layers, Truck, Zap, Package,
  FileBadge, ShieldCheck, TrendingUp, Search, Calculator, HardHat,
};
